module.exports = __webpack_public_path__ + "img/scan.6d2176b5.png";